var React = require('react');

function Close32x32 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27 7.21449L18.2145 16L27 24.7855L24.7855 27L16 18.2145L7.21449 27L5 24.7855L13.7855 16L5 7.21449L7.21449 5L16 13.7855L24.7855 5L27 7.21449Z"}));
}

Close32x32.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Close32x32;

Close32x32.default = Close32x32;
